<template>
<div class="container-fluid h-100 d-flex flex-column">
  <!-- loading animation -->
  <div class="loading abcenter" v-if="showOverlay">
    <div class="spinner-grow text-primary abcenter" role="status"></div>
  </div>
  <b-toast id="cookieconsent" title="Privacy Notice" no-auto-hide solid toaster="b-toaster-bottom-right" append-toast>
    We use cookies to improve your experience on our site. For more details, please visit <a href='https://www.privacypolicygenerator.info/live.php?token=aiL0uo7Iy0ZN0WAkDs6UTkYt1sq24Coi' target="_blank">here</a>.
  </b-toast>
  <div class="row flex-fill justify-content-center align-items-center">
    <div class="col-md-6">
      <b-alert v-model="showAlert" variant="danger" dismissible>
        {{ alertMsg }}
      </b-alert>
      <form @submit.prevent="onSubmit">
        <div class="form-group">
          <label for="exampleInputEmail1">To use NEURON, please input your email address and university/institution name</label>
          <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" v-model="useremail" required>
        </div>
        <div class="form-group">
          <input type="text" class="form-control" id="inputInstitute" aria-describedby="emailHelp" placeholder="Enter university/institute" v-model="userinstitute" required>
        </div>
        <!-- my sitekey: 6LfLfxQeAAAAAP8rkp4gP4v7CGiI0D2CPq_SJDar -->
        <!-- <vue-recaptcha sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" :loadRecaptchaScript="true" @verify="recaptcha"></vue-recaptcha> -->
        <div v-if="showCaptcha">
          <vue-recaptcha sitekey="6LfLfxQeAAAAAP8rkp4gP4v7CGiI0D2CPq_SJDar" :loadRecaptchaScript="true" @verify="recaptcha"></vue-recaptcha>
        </div>
        <button type="submit" class="btn btn-primary mt-1">Submit</button>
      </form>
    </div>
  </div>
  <footer class="icp-footer">
    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">陕ICP备2021012794号-1</a>
  </footer>
</div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import { mapActions, mapMutations } from 'vuex'
import axios from 'axios'

import { login } from '@/api.js'

export default {
  data: function() {
    return {
      useremail: '',
      userinstitute: '',
      ipaddress: '',
      showAlert: false,
      recaptchaPassed: false,
      showOverlay: false,
      alertMsg: '',
      showCaptcha: true
    }
  },
  components: { VueRecaptcha },
  mounted: function() {
    this.showCookieConsent()
    this.isShowReCaptcha()
  },
  methods: {
    showCookieConsent() {
      if (!localStorage.notice) {
        this.$bvToast.show("cookieconsent")
        localStorage.notice = "shown"
      }
    },
    async isShowReCaptcha() {
      if (!localStorage.country_name) {
        await axios.get('https://ipapi.co/json/').then(response => {
          localStorage.country_name = response.data.country_name
          this.ipaddress = response.data.ip
        })
      }
      if (localStorage.country_name === 'Singapore') {
        this.showCaptcha = false
      }
    },
    async onSubmit() {
      if (this.recaptchaPassed || localStorage.country_name === 'Singapore' || this.userinstitute === "NTU" || this.userinstitute === "Nanyang Technological University") {
        this.showOverlay = true
        // send email to backend
        try {
          let response = await login(this.useremail, this.userinstitute, this.ipaddress)
          // go to main page if can reach the backend
          this.showOverlay = false
          this.setDb("tpch")
          this.setEmail(this.useremail)
          this.$router.replace("/")
        }
        catch(err) {
          this.showOverlay = false
          this.alertMsg = 'Cannot connect to database, please try again later!'
          this.showAlert = true
        }
      } else {
        this.alertMsg = 'Please verify you are not a robot before proceeding!'
        this.showAlert = true
      }
    },
    recaptcha(response) {
      this.recaptchaPassed = true
    },
    ...mapActions([
      'setDb'
    ]),
    ...mapMutations([
      'setEmail'
    ])
  }
}
</script>
